
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getPaymentstatus} from 'sr/utils/api/masterData/paymentstatus/getPaymentstatus'
export const fetchpaymentstatus = createAsyncThunk(
  'getPaymentstatus',
  async () => {
    const response = await getPaymentstatus()
    return response?.data
  }
)


